export default "__VITE_ASSET__dJNxBaII__"